/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum AvailableMobjectTypes {
    Vehicle = 'vehicle',
    Trailer = 'trailer',
    All = 'all'
}

export function AvailableMobjectTypesFromJSON(json: any): AvailableMobjectTypes {
    return AvailableMobjectTypesFromJSONTyped(json, false);
}

export function AvailableMobjectTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableMobjectTypes {
    return json as AvailableMobjectTypes;
}

export function AvailableMobjectTypesToJSON(value?: AvailableMobjectTypes | null): any {
    return value as any;
}

